document.addEventListener('DOMContentLoaded', function () {

    const headers = document.querySelectorAll('.accordion-header');

    headers.forEach(header => {
        header.addEventListener('click', () => {
            const currentlyActive = document.querySelector('.accordion-header.active');

            if (currentlyActive && currentlyActive !== header) {
                const activeContent = currentlyActive.nextElementSibling;
                currentlyActive.classList.remove('active');
                activeContent.classList.remove('open');

                setTimeout(() => {
                    activeContent.style.display = 'none';
                }, 300);
            }

            const content = header.nextElementSibling;
            const isActive = header.classList.contains('active');

            if (!isActive) {
                header.classList.add('active');
                content.style.display = 'block';
                setTimeout(() => {
                    content.classList.add('open');
                }, 10);
            } else {
                header.classList.remove('active');
                content.classList.remove('open');
                setTimeout(() => {
                    content.style.display = 'none';
                }, 300);
            }
        });
    });

    // Get the faq_id query parameter from the URL
    // open the corresponding accordion item if it exists
    const urlParams = new URLSearchParams(window.location.search);
    const faqId = urlParams.get('faq_id');
    console.log(faqId);
    if (faqId) {
        const accordionItem = document.querySelector(`.accordion-item.${faqId}`);
        console.log(accordionItem);
        if (accordionItem) {
            const header = accordionItem.querySelector('.accordion-header');
            const content = accordionItem.querySelector('.accordion-content');

            // Open the accordion item
            header.classList.add('active');
            content.style.display = 'block';
            setTimeout(() => {
                content.classList.add('open');
            }, 10);

            // Scroll to the opened accordion item
            accordionItem.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }
});